import { render, staticRenderFns } from "./AppFixedFormFooter.vue?vue&type=template&id=2f0278e6&"
import script from "./AppFixedFormFooter.vue?vue&type=script&lang=js&"
export * from "./AppFixedFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFixedFormFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports